import React from "react";
import { Row, Card, CardBody, Col } from "reactstrap";
import BarChart from "Components/ChartJS/BarChart";
import ScatterChart from "Components/ChartJS/ScatterChart";
import DoughnutChart from "Components/ChartJS/DoughnutChart";
import LineChart from "Components/ChartJS/LineChart";

export default function ChartJsPage() {
  return (
    <div>
      <Row>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody>
              <BarChart />
            </CardBody>
          </Card>
        </Col>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody>
              <ScatterChart />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody>
              <LineChart />
            </CardBody>
          </Card>
        </Col>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody>
              <DoughnutChart />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
